import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

@Injectable()
export class BookingSupervisorBookingService {
  constructor(private http: HttpClient) {}

  public createOne(bookingId: number, personId: number): Observable<boolean> {
    return this.http.post<any>(
      `${environment.backendApiUrl}/supervisors/${personId}/bookings`,
      { bookingId, personId }
    )
  }

  public deleteOne(bookingId: number, personId: number): Observable<boolean> {
    return this.http.delete<any>(
      `${environment.backendApiUrl}/supervisors/${personId}/bookings/${bookingId}`
    )
  }
}
